module.exports = __webpack_public_path__ + "img/blueSwitch.caecfd57.svg";